import { ServiceType } from '@/shared/api/protocol-ts/api/billing_new/dto_services_new_pb';

export const HIDDEN_SERVICES = [
  ServiceType.ServiceType_Enable_3DModelsWithConditions,
  ServiceType.ServiceType_Enable_SuggestedTreatment,
  ServiceType.ServiceType_Enable_Transcriptor,
  // WA-6209: uploads are no longer metered; the per-upload counters (1..6)
  // were removed from the protocol. Dental-photo upload survives as the enabler.
  ServiceType.ServiceType_Enable_UploadDentalPhoto,
];
